<div class="container" data-cy="ops-settings-system-color-custom-color-list">
    <div class="header">
        <h4 class="title">{{ data?.title | translate }}</h4>
        <span class="description">{{ data?.description | translate }}</span>
    </div>
    <div class="main-container">
        <div *ngFor="let colorData of data?.color">
            <app-system-color-input [data]="colorData" [vessel]="vessel" [canEditVessel]="canEditVessel">
            </app-system-color-input>
        </div>
        <div class="back-button-container">
            <h6
                class="back-button"
                [class.disabled]="!canEditVessel"
                data-cy="ops-settings-system-color-custom-color-add-button"
                (click)="addCustomColorClick()">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'system-color.custom.add-button' | translate }}
            </h6>
        </div>
    </div>
</div>
